import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import NewPoolTransactionModal from 'components/modals/client/NewPoolTransactionModal'
import EditCycleModal from 'components/modals/client/EditCycleModal'
import DeleteCycleModal from 'components/modals/client/DeleteCycleModal'
import AddNewCycleModal from 'components/modals/client/AddNewCycleModal'
import StartDayModal from 'components/modals/client/StartDayModal'
import EndDayModal from 'components/modals/client/EndDayModal'
import AddConsosModal from 'components/modals/client/AddConsosModal'
import SelectUserModal from 'components/modals/client/SelectUserModal'
import SelectionModal from 'components/modals/client/SelectionModal'
import PaymentModal from 'components/modals/client/PaymentModal'
import CancelTransactionModal from 'components/modals/client/CancelTransactionModal'
import ChangeCurrentPricingModal from 'components/modals/client/ChangeCurrentPricingModal'
import AdminCodeModal from 'components/modals/client/AdminCodeModal'
import CustomerModal from 'routes/Admin/Customers/components/CustomerModal'
import LockerModal from 'routes/Admin/Lockers/components/LockerModal'
import EditBarModal from 'components/modals/client/EditBarModal'
import { clearSelectedProducts } from 'redux/modules/selectedProducts'
import { selectUser } from 'redux/modules/user'
import { startDay, endDay, changeCurrentPricing } from 'redux/modules/settings'
import { createCustomer, updateCustomer } from 'redux/modules/customer'
import { createLocker, updateLocker } from 'redux/modules/locker'
import {
  createTransactionForPool,
  addProductsToTransaction,
  transfertTransaction,
  cancelPaymentModal,
  closeTransaction,
  cancelTransaction,
  addPayment,
  removePayment,
  createCycle,
  updateCycle,
  removeCycle
} from 'redux/modules/transaction'
import { addPaymentHistory, removePaymentHistory } from 'redux/modules/history'
import { updateBarInfo } from 'redux/modules/bar'
import {
  MODAL_CLIENT_START_DAY,
  MODAL_CLIENT_SELECT_USER,
  MODAL_CLIENT_END_DAY,
  MODAL_CLIENT_OPEN_TRANSACTION,
  MODAL_CLIENT_CREATE_CYCLE,
  MODAL_CLIENT_EDIT_CYCLE,
  MODAL_CLIENT_DELETE_CYCLE,
  MODAL_CLIENT_CONSO_TRANSACTION,
  MODAL_CLIENT_PAYMENT,
  MODAL_CLIENT_PAYMENT_HISTORY,
  MODAL_CLIENT_CANCEL_TRANSACTION,
  MODAL_CLIENT_SELECTION_PRODUCTS,
  MODAL_CLIENT_SELECTION_TRANSFERT,
  MODAL_CLIENT_ADMIN_CODE,
  MODAL_CLIENT_PRICING_MODAL,
  MODAL_CLIENT_BAR_MODAL,
  MODAL_ADMIN_CREATE_CUSTOMER,
  MODAL_ADMIN_EDIT_CUSTOMER,
  MODAL_ADMIN_CREATE_LOCKER,
  MODAL_ADMIN_EDIT_LOCKER,
  hideModal
} from 'redux/modules/modals'

const mapActionCreators = {
  startDay,
  endDay,
  changeCurrentPricing,
  createTransactionForPool,
  addProductsToTransaction,
  transfertTransaction,
  clearSelectedProducts,
  cancelPaymentModal,
  cancelTransaction,
  addPayment,
  removePayment,
  closeTransaction,
  createCycle,
  updateCycle,
  removeCycle,
  selectUser,
  createCustomer,
  updateCustomer,
  createLocker,
  updateLocker,
  updateBarInfo,
  addPaymentHistory,
  removePaymentHistory,
  hideModal
}
const mapStateToProps = state => {
  return {
    currentModal: state.modals.currentModal,
    auth: state.auth,
    payload: state.modals.payload,
    players: state.players.list,
    currentDates: state.settings.currentDates,
    adminCode: state.settings.adminCode,
    pricings: state.pricings.list,
    currentPricing: state.settings.currentPricing,
    users: state.users.list,
    currentUser: state.users.currentUser,
    currentTransaction: state.transactions.currentTransaction,
    categories: state.categories.list,
    products: state.products.list,
    customers: state.customers.list,
    lockers: state.lockers.list,
    paymentTypes: state.settings.payments,
    transactions: state.transactions.list,
    history: state.history.today
  }
}
const ClientModalConductor = props => {
  const payloadArray = _.isArray(props.payload) ? props.payload : void 0
  const payload =
    payloadArray && payloadArray.length === 1 ? payloadArray[0] : props.payload
  switch (props.currentModal) {
    case MODAL_CLIENT_SELECT_USER:
      return (
        <SelectUserModal
          users={props.users || []}
          selectUser={props.selectUser}
        />
      )
    case MODAL_CLIENT_START_DAY:
      return <StartDayModal auth={props.auth} startDay={props.startDay} />
    case MODAL_CLIENT_END_DAY:
      return (
        <EndDayModal
          auth={props.auth}
          transactions={props.transactions}
          endDay={props.endDay}
          startDate={props.currentDates.startDate}
        />
      )
    case MODAL_CLIENT_CANCEL_TRANSACTION:
      return (
        <CancelTransactionModal
          transaction={payload}
          cancelTransaction={props.cancelTransaction}
        />
      )
    case MODAL_CLIENT_OPEN_TRANSACTION:
      return (
        <NewPoolTransactionModal
          table={payload}
          players={props.players}
          currentUser={props.currentUser}
          currentPricing={props.currentPricing}
          pricings={props.pricings}
          createTransactionForPool={props.createTransactionForPool}
        />
      )
    case MODAL_CLIENT_EDIT_CYCLE:
      return (
        <EditCycleModal
          dayStartDate={props.currentDates.startDate}
          cycle={payload}
          transaction={props.currentTransaction}
          updateCycle={props.updateCycle}
        />
      )
    case MODAL_CLIENT_CREATE_CYCLE:
      return (
        <AddNewCycleModal
          transaction={props.payload}
          createCycle={props.createCycle}
          currentPricing={props.currentPricing}
          pricings={props.pricings}
        />
      )
    case MODAL_CLIENT_DELETE_CYCLE:
      return (
        <DeleteCycleModal
          cycle={props.payload}
          transaction={props.currentTransaction}
          removeCycle={props.removeCycle}
        />
      )
    case MODAL_CLIENT_CONSO_TRANSACTION:
      return (
        <AddConsosModal
          transaction={payload}
          categories={props.categories}
          products={props.products}
          addProducts={props.addProductsToTransaction}
        />
      )
    case MODAL_CLIENT_PAYMENT:
      return (
        <PaymentModal
          transaction={props.currentTransaction}
          user={props.currentUser}
          paymentTypes={props.paymentTypes}
          cancelPaymentModal={props.cancelPaymentModal}
          addPayment={props.addPayment}
          removePayment={props.removePayment}
          closeTransaction={props.closeTransaction}
        />
      )
    case MODAL_CLIENT_PAYMENT_HISTORY:
      const hist = props.history.find(h => h.key === payload.key) || payload
      return (
        <PaymentModal
          transaction={hist.transaction}
          hist={hist}
          user={props.currentUser}
          paymentTypes={props.paymentTypes}
          addPayment={props.addPaymentHistory}
          removePayment={props.removePaymentHistory}
        />
      )
    case MODAL_CLIENT_SELECTION_PRODUCTS:
      return (
        <SelectionModal
          selectedProducts={props.payload}
          addProductsToTransaction={props.addProductsToTransaction}
          clearSelectedProducts={props.clearSelectedProducts}
        />
      )
    case MODAL_CLIENT_SELECTION_TRANSFERT:
      return (
        <SelectionModal
          currentTransaction={payload}
          transfertTransaction={props.transfertTransaction}
          clearSelectedProducts={props.clearSelectedProducts}
        />
      )
    case MODAL_CLIENT_PRICING_MODAL:
      return (
        <ChangeCurrentPricingModal
          changeCurrentPricing={props.changeCurrentPricing}
          currentPricing={props.currentPricing}
          pricings={props.pricings}
        />
      )
    case MODAL_CLIENT_ADMIN_CODE:
      return (
        <AdminCodeModal
          adminCode={props.adminCode}
          hideModal={props.hideModal}
        />
      )
    case MODAL_ADMIN_CREATE_CUSTOMER:
      return (
        <CustomerModal
          customersNames={props.customers.map(c =>
            _.lowerCase(`${c.customers_first_name} ${c.customers_last_name}`)
          )}
          createCustomer={props.createCustomer}
        />
      )
    case MODAL_ADMIN_EDIT_CUSTOMER:
      return (
        <CustomerModal
          customer={payload}
          customersNames={props.customers.map(c =>
            _.lowerCase(`${c.customers_first_name} ${c.customers_last_name}`)
          )}
          updateCustomer={props.updateCustomer}
        />
      )
    case MODAL_ADMIN_CREATE_LOCKER:
      return (
        <LockerModal
          lockerNames={props.lockers.map(l => _.lowerCase(`${l.name}`))}
          customers={props.customers}
          createLocker={props.createLocker}
        />
      )
    case MODAL_ADMIN_EDIT_LOCKER:
      return (
        <LockerModal
          locker={payload}
          lockerNames={props.lockers.map(l => _.lowerCase(`${l.name}`))}
          customers={props.customers}
          updateLocker={props.updateLocker}
        />
      )
    case MODAL_CLIENT_BAR_MODAL:
      return (
        <EditBarModal
          transaction={props.payload}
          updateBarInfo={props.updateBarInfo}
        />
      )
    default:
      return null
  }
}

export default connect(mapStateToProps, mapActionCreators)(ClientModalConductor)



// WEBPACK FOOTER //
// ./src/containers/ClientModalConductor.js